import { SHIFT_DISCOVERY_ENABLE_LOCATION_PERMISSIONS_PATH } from "../../ShiftDiscovery/paths";
import { type NavigateToModalFunction } from "../../ShiftDiscovery/useShiftModalsDataContext";
import { useCheckPreBookingState } from "../Booking/useCheckPreBookingState";

interface UseBidActionProps {
  shiftId: string | undefined;
  workplaceId?: string;
  navigateToModal: NavigateToModalFunction;
  onCanProceed: () => void;
}

export function useBidAction(props: UseBidActionProps) {
  const { shiftId, workplaceId, navigateToModal, onCanProceed } = props;

  const { geolocationIsUnavailable, isPreBookingChecksLoading } = useCheckPreBookingState({
    workplaceId,
    shiftId: shiftId ?? "",
  });

  const attemptBidAction = () => {
    // Ideally we could call performChecksBeforeBooking here, but those checks lead to paths that are not ready to handle shift auctions yet, and may navigate to the booking modal
    if (geolocationIsUnavailable) {
      navigateToModal(SHIFT_DISCOVERY_ENABLE_LOCATION_PERMISSIONS_PATH);
      return;
    }

    onCanProceed();
  };

  return {
    attemptBidAction,
    isLoading: isPreBookingChecksLoading,
  };
}
